import { NgModule } from "@angular/core";
import { FormFieldStateDirective } from "./form-field-state.directive";
import { FormFieldHintStateDirective } from './form-field-hint-state.directive'
import { MatErrorStateDirective } from "./mat-error-state.directive";
import { TagErrorStateDirective } from './tag-error-state.directive'
import { TagFormFieldStateDirective } from './tag-form-field-state.directive'
import { ErrorStateDirective } from "./error-state.directive";
import { ErrorStateWithLengthDirective } from "./error-state-with-length.directive";
import { ErrorStateWithValidationDirective } from "./error-state-with-validation.directive";

@NgModule({
  declarations: [
    FormFieldStateDirective,
    FormFieldHintStateDirective,
    MatErrorStateDirective,
    TagErrorStateDirective,
    TagFormFieldStateDirective,
    ErrorStateDirective,
    ErrorStateWithLengthDirective,
    ErrorStateWithValidationDirective
  ],
  exports: [
    FormFieldStateDirective,
    FormFieldHintStateDirective,
    MatErrorStateDirective,
    TagErrorStateDirective,
    TagFormFieldStateDirective,
    ErrorStateDirective,
    ErrorStateWithLengthDirective,
    ErrorStateWithValidationDirective
  ]
})
export class FormFieldStateModule {}